import { combineReducers } from 'redux';
import { reducer as reduxAsyncConnect } from 'redux-connect';

import cookies from 'common/reducers/cookies';
import mentionSuggestions from 'common/reducers/mentionSuggestions';
import notifications from 'common/reducers/notifications';
import postQueries from 'common/reducers/postQueries';
import posts from 'common/reducers/posts';
import postsActivity from 'common/reducers/postsActivity';
import serverResponse from 'common/reducers/serverResponse';
import userReactions from 'common/reducers/userReactions';
import widget from 'common/reducers/widget';

export default combineReducers({
  cookies,
  mentionSuggestions,
  notifications,
  posts,
  postsActivity,
  postQueries,
  serverResponse,
  reduxAsyncConnect,
  userReactions,
  widget,
});
